import React, { useEffect } from 'react';
import { logout } from '../services/auth';
import { useNavigate } from 'react-router-dom';

export const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        logout();
        navigate('/login');
    }, [navigate]);

    return <p>Logging out...</p>;
};